<item-grid [items]="offers()" (loadMore)="loadResults()" [loading]="loader()" [isFinal]="maxxed()" [item_width]="300" [item_template]="offer" item_name="Redemptions" item_track_key="redemption">
    <ng-template #offer let-offer>
      <div class="f-main-center">
        <redemption-card [redemption]="offer" (editRequest)="requestEdit($event)"></redemption-card>
      </div>
    </ng-template>
</item-grid>

<ng-template #editor>
  <form class="p-8">
      <div class="custom-field max" [class.has-error]="!!savings.errors">
          <label>Enter Savings</label>
          <div class="prefix"><mat-icon>euro</mat-icon></div>
          <input matInput placeholder="€#.##" type="number" [formControl]="savings">
          <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: savings, label: 'Savings' }"></ng-container>
  
      </div>
  </form>
</ng-template>

<ng-template #errorRender let-field let-label="label">
  @if(field?.touched && field?.errors; as error){
    <mat-error>
      @if(error.required){
          Please enter {{label}}
      } @else if(error.min){
          {{label}} must be a positive number
      } @else {
        {{label}} is invalid
      }
    </mat-error>
  } @else {
    <mat-hint>&nbsp;</mat-hint>
  }
</ng-template>